import { type DesktopDatePickerProps } from "@mui/x-date-pickers/DesktopDatePicker";
import { type Dayjs } from "dayjs";

/**
 * What `ui/date-picker` hands its calendar, ahead of the caller's props so each stays overridable.
 * Figma labels the week `Su Mo Tu …` where MUI's default is one capital letter, and lays the year list
 * out three to a row where MUI's desktop default is four.
 */
export const CALENDAR_DEFAULTS = {
  dayOfWeekFormatter: (date: Dayjs) => date.format("dd"),
  yearsPerRow: 3,
} satisfies Pick<DesktopDatePickerProps, "dayOfWeekFormatter" | "yearsPerRow">;
